export const AGENT511 = 'AGENT511';
export const AGENT_511 = 'agent_511';
export const SESSION_ENDED = 'session_ended';
export const SMS_MESSAGE = 'sms_message';
export const TEXT_TO_911_MESSAGE = 'Latest text-to-911 message';
